import * as React from "react"
import 'intersection-observer';
import { InView } from 'react-intersection-observer';
import { Action, IOWidget, mk_widget, Pair } from "widgets-for-react"
import { Id, CMSState, ImageSize, Url } from "../../../../cms/blocks/types.gen";
import { link, getClassName, linkWrapper } from "../../../../cms/blocks/utils.gen"
import { ImageContainer } from "../../../../cms/blocks/widgets/ImageContainer.gen";
import { blockInviewHandler } from "../../../utils/inview_utils";
import { PublicSite_CustomPageData } from "../../../application.mod";
import { WordPress } from "../../../../wordpress/wordpress_api";
import { toRelativeUrl } from "../../../../../helpers";
import { ButtonData } from "../../../../wordpress/types_and_parser/extra_types.mod";
import { getImageAttribute } from "../../../utils/extra_images.mod";

export type CtaAttributes = {
    blockName: 'vidda/cta'
    title: string
    intro: string
    image?: WordPress.MediaResponse
    image_position?: 'left' | 'right'
    primary_button?: ButtonData
    secondary_button?: ButtonData
}

export interface CtaInterface {
    blockName: 'vidda/cta'
    attrs: CtaAttributes
}

export type CtaBlockProps<extra_images> = CtaAttributes

export type CtaBlockStyle = Partial<{
  block_contentwidth_classname: string
  block_fullwidth_classname: string
  inview_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  visual_classname: string
  image_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function CtaBlock<customBlockData, extra_images>(
  props: CtaBlockProps<extra_images>,
  options?: { style?: CtaBlockStyle; key?: string }
): IOWidget<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>, Action<CMSState<customBlockData, extra_images, never>>> {
  return (cmsState: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => (
        <section className={`block block--cta${props.image && props.image.media_details ? (props.image_position === 'right' ? ' block--cta-image block--cta-image--right' : ' block--cta-image block--cta-image--left' ) : ' block--cta-text'}
        `}>
          <div className={`block__inner grid--block${props.image && props.image.media_details ? ' container--xl ' : ' container--l'}
        `}>
            <div className="block__content">
              <header className="block__header">
                {props.title && <h2 className="block__title typo--3xl">{props.title}</h2>}
              </header>
              {props.image && props.image.media_details ?
              <>
                {props.intro && (
                  <div className="text--styled typo--xs" dangerouslySetInnerHTML={{ __html: props.intro }}></div>
                )}
                {(props.primary_button || props.secondary_button) && (
                  <footer className="block__footer">
                    {props.primary_button && props.primary_button.url && props.primary_button.text && (
                    <>
                        {link(linkWrapper({title:props.primary_button.text, url:props.primary_button.url}),
                          { classname: 'button button--secondary' },
                          props.primary_button.text
                          )}
                    </>
                    )}
                    {props.secondary_button && props.secondary_button.text && props.secondary_button.url && (
                    <>
                        {link(linkWrapper({title:props.secondary_button.text,url:props.secondary_button.url}),
                        { classname: 'link link--primary' },
                        props.secondary_button.text
                        )}
                    </>
                    )}
                </footer>
                )}
              </> :
              <div className="block__wrapper">
              {props.intro && (
                <div className="text--styled typo--xs" dangerouslySetInnerHTML={{ __html: props.intro }}></div>
              )}
              {(props.primary_button || props.secondary_button) && (
                <footer className="block__footer">
                  {props.primary_button && (
                  <>
                      {link(linkWrapper({title:props.primary_button.text,url:props.primary_button.url}),
                        { classname: 'button button--secondary' },
                        props.primary_button.text
                        )}
                  </>
                  )}
                  {props.secondary_button && (
                  <>
                      {link(linkWrapper({title:props.secondary_button.text,url:props.secondary_button.url}),
                      { classname: 'link link--primary' },
                      props.secondary_button.text
                      )}
                  </>
                  )}
              </footer>
              )}
          </div>
          }
          </div>

          {props.image && props.image.media_details && (
            <div className="block__visual fit-object">
              <img
                src={getImageAttribute(props.image, 'square', 'source_url')}
                width={getImageAttribute(props.image, 'square', 'width')}
                height={getImageAttribute(props.image, 'square', 'height')}
                className="block__image"
                alt={props.image.alt_text ? props.image.alt_text : ''}
              />
            </div>
          )}

          </div>
        </section>
      ),
    })
}
